import { observer } from 'mobx-react-lite';
import * as R from 'ramda';
import * as React from 'react';
import {
  NestedDefaultPropsProvider,
  withDefaultProps,
} from 'react-default-props-context';
import { useGetSelfTest } from 'src/api/queries/useGetSelfTest';
import { SelfTestT } from 'src/api/types/SelfTestT';
import { SelfTestState } from 'src/selfTest/SelfTestState';

type PropsT = React.PropsWithChildren<{}>;

type DefaultPropsT = {};

export const SelfTestStateProvider = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    const getSelfTest = useGetSelfTest();
    const [selfTestState] = React.useState(
      () => new SelfTestState({ selfTest: undefined })
    );

    React.useEffect(() => {
      if (getSelfTest.status === 'success' && !selfTestState.selfTest) {
        selfTestState.setSelfTest(getSelfTest.data as SelfTestT);
      }
    }, [getSelfTest.status, getSelfTest.data, selfTestState]);

    const getDefaultProps = () => {
      return R.mergeAll([
        {
          selfTest: () => getSelfTest.data as SelfTestT,
          selfTestRS: () => getSelfTest.status,
        },
        {
          setPortalElm: () => selfTestState.setPortalElm,
          portalElm: () => selfTestState.portalElm,
        },
        {
          ad: () => selfTestState.pagesState.ad,
          explanation: () => selfTestState.pagesState.explanation,
          explanationPageIdx: () => selfTestState.pagesState.explanationPageIdx,
          goToExplanationPage: () =>
            selfTestState.pagesState.goToExplanationPage,
          goToNextPage: () => selfTestState.pagesState.goToNextPage,
          goToSummaryPage: () => selfTestState.pagesState.goToSummaryPage,
          pageIdx: () => selfTestState.pagesState.pageIdx,
          question: () => selfTestState.pagesState.question,
          questionDisplayNr: () => selfTestState.pagesState.questionDisplayNr,
          questionIdx: () => selfTestState.pagesState.questionIdx,
          questions: () => selfTestState.pagesState.questions,
          summaryPageIdx: () => selfTestState.pagesState.summaryPageIdx,
          rollBackToPreviousPage: () =>
            selfTestState.pagesState.rollBackToPreviousPage,
        },
        {
          answerQuestion: () => selfTestState.answersState.answerQuestion,
          getScoreRange: () => selfTestState.answersState.getScoreRange,
          givenAnswers: () => selfTestState.answersState.givenAnswers,
          riskfactors: () => selfTestState.answersState.riskfactors,
          tips: () => selfTestState.answersState.tips,
          totalScore: () => selfTestState.answersState.totalScore,
        },
      ]);
    };

    return (
      <NestedDefaultPropsProvider value={getDefaultProps()}>
        {props.children}
      </NestedDefaultPropsProvider>
    );
  })
);
